// src/App.js
import React, { useState, useEffect, useCallback } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import "./App.css";

import LoginPage from "./components/LoginPage";
import ChangePassword from "./components/ChangePassword";
import ThanhDieuHuong from "./components/ThanhDieuHuong";
import DiemDanh from "./components/DiemDanh";
import Lich from "./pages/Lich";
import { NumCoChu } from "./vo";
import BangTin from "./pages/BangTin";
import TrangCuaToi from "./pages/TrangCuaToi";
import ViecNha from "./pages/ViecNha";
import DiCho from "./pages/DiCho";
import DanhBa from "./pages/DanhBa";
import ChiTieu from "./pages/ChiTieu";
import MeoVat from "./pages/MeoVat";
import SanChoi from "./pages/SanChoi";
import QuanTri from "./pages/QuanTri";
import { fetchData } from "./services/api";

function App() {
  const [user, setUser] = useState(null);
  const [showChangePassword, setShowChangePassword] = useState(false);
  // Số việc người nhà đang nhờ mình — để hiện con số ngay trên thanh điều hướng.
  const [soViec, setSoViec] = useState({ chua_xong: 0, qua_han: 0 });
  const dieuHuong = useNavigate();

  // Hỏi lại máy chủ xem còn mấy việc chưa làm.
  // Gọi lúc mở app, và gọi lại mỗi khi trang Việc nhà có thay đổi (báo đã làm,
  // nhờ thêm việc, xóa việc) — nhờ vậy con số không bao giờ nói dối.
  const taiSoViec = useCallback(() => {
    fetchData("viec/dem")
      .then((d) => setSoViec(d))
      .catch(() => {
        // Mất mạng thì thôi, không hiện con số còn hơn hiện con số sai.
      });
  }, []);

  // 📋 Số việc của chủ nhà — số đỏ trên nút ⚙️ (N5, anh chốt 14/09).
  // Chỉ tài khoản quản trị hỏi; máy chủ cũng chặn người khác (403).
  const [soViecChuNha, setSoViecChuNha] = useState(0);
  const laQuanTri = user && user.role === "admin";
  const taiSoViecChuNha = useCallback(() => {
    if (!laQuanTri) return;
    fetchData("quan-tri/viec-chu-nha")
      .then((d) => setSoViecChuNha(d.so || 0))
      .catch(() => {});
  }, [laQuanTri]);

  useEffect(() => {
    taiSoViecChuNha();
  }, [taiSoViecChuNha]);

  // 🔴 Chấm đỏ Sân chơi (N7, SC1): có bài của người khác mới hơn lần mình mở.
  // Hỏi lại mỗi lần chuyển trang — rẻ (một câu EXISTS), và đỡ phải chạy nền.
  // Chấm, không phải con số (chân dung 5.4).
  const viTri = useLocation();
  const [coBaiMoi, setCoBaiMoi] = useState(false);
  useEffect(() => {
    if (!user) return;
    if (viTri.pathname === "/san-choi") return; // đang ở Sân chơi thì trang tự báo đã xem
    fetchData("san-choi/moi")
      .then((d) => setCoBaiMoi(Boolean(d.co_bai_moi)))
      .catch(() => {});
  }, [user, viTri.pathname]);
  const daXemSanChoi = useCallback(() => setCoBaiMoi(false), []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("user");
    if (!token || !userData) return;

    // Hiện tạm bản đã lưu trong máy để vào app ngay, không phải chờ mạng.
    try {
      setUser(JSON.parse(userData));
    } catch (e) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return;
    }

    // Rồi hỏi máy chủ xem quyền hạn MỚI NHẤT là gì và cập nhật lại.
    // Nhờ vậy admin vặn quyền cho ai thì lần mở app sau người đó đã thấy đúng,
    // không phải đăng xuất rồi đăng nhập lại mới có hiệu lực.
    fetchData("me")
      .then((kq) => {
        if (kq && kq.user) {
          setUser(kq.user);
          localStorage.setItem("user", JSON.stringify(kq.user));
        }
      })
      .catch(() => {
        // Không hỏi được (mất mạng chẳng hạn) thì cứ dùng bản đã lưu.
      });

    taiSoViec();
  }, [taiSoViec]);

  const handleLogin = (userData) => {
    setUser(userData);
    taiSoViec();
    // Đăng nhập xong vào thẳng VIỆC NHÀ, không phải Bảng tin.
    //
    // Theo tài liệu chân dung mục 5.6: "màn hình đầu tiên sau đăng nhập phải
    // là việc của tôi". Trước đây rơi vào Bảng tin, phải tự bấm sang tab mới
    // biết ai nhờ mình cái gì — mà đã phải tự bấm thì phần lớn sẽ không bấm.
    dieuHuong("/viec-nha");
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    setShowChangePassword(false);
    dieuHuong("/");
  };

  if (!user) return <LoginPage onLogin={handleLogin} />;

  const laAdmin = user.role === "admin";

  return (
    <div className="app-container">
      <header className="app-header">
        <div>
          <h1 className="app-title">🏠 Quản gia nhà mình</h1>
          <p className="app-subtitle">Xin chào, {user.full_name}!</p>
        </div>
        <div className="nhom-nut-dau-trang">
          {/* Núm cỡ chữ đặt Ở ĐÂY, không giấu trong trang cài đặt nào cả.
              Người cần nó nhất là người đang không đọc được chữ — bắt họ
              đi tìm qua hai lớp menu là hỏng chính mục đích. */}
          <NumCoChu />
          <button
            onClick={() => setShowChangePassword(!showChangePassword)}
            className="nut nut-vang"
          >
            {showChangePassword ? "❌ Đóng" : "🔑 Đổi mật khẩu"}
          </button>
          <button onClick={handleLogout} className="nut nut-do">
            Đăng xuất
          </button>
        </div>
      </header>

      <ThanhDieuHuong user={user} soViec={soViec} soViecChuNha={soViecChuNha} coBaiMoi={coBaiMoi} />

      <main>
        {/* Diem danh: khoi dau tien sau khi dang nhap, o moi trang.
            Da diem danh roi thi no tu thu lai thanh mot dong manh. */}
        <DiemDanh user={user} />

        {showChangePassword && (
          <ChangePassword user={user} onLogout={handleLogout} />
        )}

        <Routes>
          <Route path="/bang-tin" element={<BangTin user={user} />} />
          <Route path="/trang-cua-toi" element={<TrangCuaToi user={user} />} />
          <Route
            path="/viec-nha"
            element={<ViecNha user={user} onDoiViec={taiSoViec} />}
          />
          <Route path="/lich" element={<Lich user={user} />} />
          <Route path="/di-cho" element={<DiCho user={user} />} />
          <Route path="/danh-ba" element={<DanhBa user={user} />} />
          <Route path="/chi-tieu" element={<ChiTieu user={user} />} />
          {/* N6 — /meo-vat/:id để lời khen trên Bảng tin bấm vào tới thẳng mẹo đó */}
          {/*      Một route, `:id?` không bắt buộc — chuyển qua lại danh sách ↔ một mẹo
                   không dựng lại trang, không tải lại danh sách. */}
          <Route path="/meo-vat/:id?" element={<MeoVat user={user} />} />
          <Route path="/san-choi" element={<SanChoi user={user} onDaXem={daXemSanChoi} />} />

          {/* Chặn ngay tại đây: người không phải admin gõ thẳng địa chỉ
              /quan-tri vào thanh địa chỉ cũng bị đẩy về Bảng tin.
              (Máy chủ vẫn kiểm tra quyền độc lập — giao diện chỉ là lớp
              ngoài cùng, không phải nơi quyết định.) */}
          <Route
            path="/quan-tri"
            element={
              laAdmin ? (
                <QuanTri onDoiViecChuNha={taiSoViecChuNha} />
              ) : (
                <Navigate to="/viec-nha" replace />
              )
            }
          />

          {/* Vào thẳng trang chủ, hoặc gõ địa chỉ không tồn tại -> về Việc nhà */}
          <Route path="*" element={<Navigate to="/viec-nha" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
